import type { AppConfig } from '../../rewards/models/rewards-v2.models';

/** CWS-1805: key of the family plan flag in `AppConfig.features` (libs/core feature flag registry). */
export const FAMILY_PLAN_FEATURE = 'family_plan';

/** True only when the server resolved the flag as on; a missing config or flag counts as off. */
export function isFeatureOn(config: AppConfig | null | undefined, key: string): boolean {
  return config?.features?.[key] === true;
}
